import type { PageConfig } from "../types";

export const page: PageConfig = {
  title: "MP Events",
  description: "Browse sensor events and anomalies across time.",
  icon: "alerts-outline",
  order: 20,
};
